import { jsx as _jsx } from "react/jsx-runtime";
var ThumbsUp = function ThumbsUp(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    width: size,
    height: 1.224 * size,
    viewBox: "0 0 49 60",
    fill: "none",
    className: className,
    children: /*#__PURE__*/_jsx("path", {
      d: "M39.621 27.212c-5.279-4.27-6.448-4.748-7.173-12.887C31.844 8.062 35.028 1 29.466 1c-7.254 0-9.672 9.455-7.254 18.87 0 0-9.067-1.076-11.203-.558-2.176.559-6.77 3.152-5.36 8.418-.443.4-5.28 3.033-2.096 8.418 0 0-4.352 3.87-1.692 8.299 0 0-3.224 8.657 4.473 10.812 7.738 2.154 29.378 8.697 36.793-3.192 7.94-12.647 2.136-20.267-3.506-24.855zM5.69 27.77s5.802-1.516 12.25.36M3.553 36.148s5.965-2.154 12.13-.279M1.901 44.447s6.77-1.835 10.64.44",
      stroke: !ignoreColor ? color : undefined,
      strokeWidth: 2,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
export default ThumbsUp;